// extracted by mini-css-extract-plugin
export var centerText = "_6u-8";
export var container = "_6u-0";
export var doughnutContainer = "_6u-7";
export var legend = "_6u-a";
export var legendItemColorDisplay = "_6u-b";
export var legendItemLabel = "_6u-d";
export var legendItemValue = "_6u-c";
export var lg = "_6u-5";
export var maxWidth = "_6u-9";
export var md = "_6u-4";
export var responsive = "_6u-6";
export var sm = "_6u-3";
export var xs = "_6u-2";
export var xxs = "_6u-1";